import { PageBlueprint, createFrontendPlugin, createRouteRef } from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { notificationsAdminPermission } from '@platform/plugin-slack-notifications-common';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

export const rootRouteRef = createRouteRef();

/**
 * Gouvernance › Notifications Slack, réservée à `platform.notifications.admin`.
 * pluginId `slack-notifications` : `notifications` est celui du plugin officiel.
 */
const adminPage = PageBlueprint.make({
  params: {
    path: '/notifications-slack',
    routeRef: rootRouteRef,
    title: 'Notifications Slack',
    icon: <NotificationsActiveIcon />,
    noHeader: true,
    loader: () =>
      import('./components/NotificationsAdminPage').then(m => (
        <RequirePermission permission={notificationsAdminPermission}>
          <m.NotificationsAdminPage />
        </RequirePermission>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'slack-notifications',
  routes: { root: rootRouteRef },
  extensions: [adminPage],
});
